module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-with-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }, [_c('div', {
    staticClass: "element-number case-upper"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("THE LETTER")])]), _vm._v(" "), _c('div', {
    staticClass: "heading-ornament-block heading-ornament-aspect-wide"
  }, [_c('div', {
    staticClass: "heading-ornament-size-container"
  }, [_c('img', {
    staticClass: "heading-ornament-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/heading-swash-ornate-screen.png"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('blockquote', {
    staticClass: "written-note block-height-not-mult-of-line-height"
  }, [_c('div', {
    staticClass: "written-note-group written-note-indented-group"
  }, [_c('p', {
    staticClass: "written-note-content written-note-indented-content"
  }, [_vm._v("…Taking into account how much of an asset this missive could be to you once in your possession, I think the sum of £10,000.00 is a fair price to pay. It would also buy my silence on another matter that could seriously damage your future.")]), _vm._v(" "), _c('p', {
    staticClass: "written-note-content written-note-indented-content"
  }, [_vm._v("I will be most heartened to hear of your positive response, upon which I will provide you with the bank details you will require to make the deposit. You have my honourable word that once payment has been made, you will never hear from me again.")]), _vm._v(" "), _c('p', {
    staticClass: "written-note-content written-note-indented-content"
  }, [_vm._v("Yours as always, my dark little angel,")]), _vm._v(" "), _c('p', {
    staticClass: "written-note-content written-note-indented-content"
  }, [_vm._v("Ouma")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-s"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("S")]), _vm._v("he sat rigid, her breath stilled; the ability to move instantly torn away from her. Her heart, the only part of her that showed she was still alive, pounded painfully in her chest. The seconds passed slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Tick tock…")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Tick tock…")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The ancient grandfather clock in the corner loudly marked the countdown as her life flashed before her, to seemingly spiral out of control. Every misdeed, every sin, every moment of cruelty, every single death – natural or otherwise – suddenly came back to haunt her, courtesy of the letter before her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her hand began to shake, the spell broken.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘A fair price!’ she raged to the empty room. Her legs, finding the momentum she needed to stand up, propelled her from the armchair. She viciously kicked at the brass captain’s floor lamp, sending it toppling over. It landed with a crash against the sideboard, scattering paperwork into the air. She watched the sheets of A4 undulate gently from side to side like a feather, before coming to rest on the blue-gold Isfahan rug.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘“Honourable word!” Pah, that woman wouldn’t know an honourable bloody word if it jumped up and bit her on her bony ass…’ She poured herself a large Scotch and stood in front of the log fire, nursing the glass close to her chest, willing her heart to slow down, to give her poor ribs a bit of relief. The glowing embers of the logs warmed the sudden chill that had enveloped her sitting room. She had always known the evidence she needed to prove her heritage was out there somewhere, but she had clearly been a fool to think the outcome would have been anything different than what she now held in her hand; a letter of extortion and blackmail from a woman she had thought long dead. She glanced at the screen of her laptop, the flashing ‘jobs’ alert pulsating in time with her heartbeat. In that split instant, her hand had been forced.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The plans she had tentatively made would now have to be more fluid, a bit like the amber liquid in her glass. She almost threw the last mouthful down her throat in haste, it burned beautifully and gave way to a cynical cackle.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘“Dark little angel”. How woefully typical of her, always trying to balance evil with good…’ She slammed the glass down and grabbed her jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Actually, now she had said it out loud, she suddenly felt quite an affection for the moniker. Her fingers tightly gripped the vial in her pocket, its purpose now clear…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("… and just like that, the Dark Angel was born.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dd15b90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter003.vue
// module id = 87
// module chunks = 0